import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Breadcrumbs,
  Typography,
  TextField,
  Container,
  Grid,
  Box,
  MenuItem,
  IconButton,
  Pagination,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { getName } from "../Other/common";
import { toast } from "react-toastify";
import { useTheme } from "@emotion/react";
import { Select, FormControl, InputLabel } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { BASE_URL } from "../../urlConfig/Url";

const SubLocationMaster = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [cid, setCID] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [plantCode, setPlantCode] = useState("");
  const [plantName, setPlantName] = useState("");
  const [plantAddress, setPlantAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [status, setStatus] = useState("");

  // error state
  const [plantCodeError, setPlantCodeError] = useState(false);
  const [plantAddressError, setPlantAddressError] = useState(false);
  const [stateError, setStateError] = useState(false);
  const [statusError, setStatusError] = useState(false);

  const [companies, setCompanies] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [cName, setCName] = useState([]);
  const [formMode, setFormMode] = useState("initial");

  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    fetchCompanies();
    fetchCompaniesName();
  }, []);

  const fetchCompanies = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/getAllSubLocationCode"
      );
      if (response.data.success) {
        setCompanies(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const fetchCompaniesName = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/getAllLocationCode"
      );
      if (response.data.success) {
        setCName(response.data.response);
        // console.log("HELLO", response.data.response);
      }
    } catch (error) {
      toast.error("Error fetching company data:", error);
    }
  };

  const formvalidation = () => {
    let isValid = true;
    if (plantCode.trim() === "") {
      setPlantCodeError(true);
      isValid = false;
    }else {
      setPlantAddressError(false);
    }
    if (plantAddress.trim() === "") {

      setPlantAddressError(true);
      isValid = false;
    }else {
      setPlantAddressError(false);
    }
    if (state.trim() === "") {
      setStateError(true);
      isValid = false;  
    }else {
      setStateError(false);
    }
    if (status.trim() === "") {
      setStatusError(true);
      isValid = false;  
    } else {
      setStatusError(false);
    }
    return isValid;
  }

  const onSubmit = async () => {
   if ( formvalidation() ) {
     
   
    const data = {
      Loc_Code: plantCode,
      SubLoc_Code: plantAddress,
      SubLoc_Name: state,
      Status: status,
      CreatedBy: getName().Name,
    };
    // console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/insertSubLocationDetails",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting company data:", error);
      toast.error("An error occurred while adding the company.");
    } 
  }else {
      toast.error("Please fill in all required fields.");
    }
  };
  

  const onUpdate = async () => {
    const data = {
      // PlantID: cid,
      Loc_Code: plantCode,
      SubLoc_Code: plantAddress,
      SubLoc_Name: state,
      Status: status,
      ModifyBy: getName().Name,
    };
    //   console.log(data)
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/updateSubLocationDetails",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating company data:", error);
      toast.error("An error occurred while updating the company.");
    }
  };

  const resetForm = () => {
    setCID("");
    setCompanyName("");
    setPlantCode("");
    setPlantName("");
    setPlantAddress("");
    setCity("");
    setState("");
    setStatus("");
  };

  const handleAddNew = () => {
    setFormMode("add");
    resetForm();
  };

  const handleCancel = () => {
    resetForm();
    setFormMode("initial");
    stopErrorHelper();
  };

  useEffect(() => {
    const result = companies.filter((company) =>
      Object.entries(company).some(([key, value]) => {
        // Skip null or undefined values
        if (value == null) return false;

        // Convert to string and compare
        return value
          .toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
      })
    );
    setFilteredRows(result);
  }, [searchTerm, companies]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const stopErrorHelper =()=>{
    setPlantCodeError(false);
    setPlantAddressError(false);
    setStateError(false);
    setStatusError(false);
  }

  const handleRowSelect = (company) => {
    setCID(company.Loc_Id);
    setPlantCode(company.Loc_Code); // Make sure this is the correct property
    setPlantAddress(company.SubLoc_Code);
    setState(company.SubLoc_Name);
    setStatus(company.Status);
    setFormMode("edit");
    stopErrorHelper();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const paginatedRows = filteredRows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <>
      <Container maxWidth="lg">
        <Box sx={{ mt: 1, mb: 2 }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              to="/dashboard/dashbordhome"
              style={{
                textDecoration: "none",
                color: theme.palette.primary.main,
              }}
            >
              Home
            </Link>
            <Typography color="textPrimary">Plant Master</Typography>
          </Breadcrumbs>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }} key={cid || "new"}>
            <Typography variant="h6" mb={2} sx={{ textAlign: "left" }}>
              Sub Location Master (* Fields Are Mandatory)
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Location Code (*)"
                  name="Location Code"
                  fullWidth
                  size="small"
                  value={plantCode} // Changed from "plantCode" to plantCode
                  error={plantCodeError}
                  helperText={plantCodeError ? "Location Code is required" : ""}
                  onChange={(e) => setPlantCode(e.target.value)}
                  disabled={formMode === "initial" || formMode === "edit"}
                >
                  {cName.map((company) => (
                    <MenuItem key={company.Loc_Code} value={company.Loc_Code}>
                      {company.Loc_Code}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Sub Location Desc (*)"
                  name="Sub Location Desc"
                  fullWidth
                  size="small"
                  value={plantAddress}
                  error={plantAddressError}
                  helperText={
                    plantAddressError ? "Sub Location Desc is required" : ""
                  }
                  onChange={(e) => setPlantAddress(e.target.value)}
                  disabled={formMode === "initial" || formMode === "edit"}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  label="Sub Location Name (*)"
                  name="Sub Location Name"
                  fullWidth
                  size="small"
                  value={state}
                  error={stateError}
                  helperText={stateError ? "Sub Location Name is required" : ""}
                  onChange={(e) => setState(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Status(*)"
                  name="Status"
                  fullWidth
                  size="small"
                  value={status}
                  error={statusError}
                  helperText={statusError ? "Status is required" : ""}
                  onChange={(e) => setStatus(e.target.value)}
                  disabled={formMode === "initial"}
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Deactive">Deactive</MenuItem>
                </TextField>
              </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" mt={5} spacing={1}>
              {formMode === "initial" && (
                <Grid item>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleAddNew}
                  >
                    <AddIcon />
                    Add New
                  </Button>
                </Grid>
              )}

              {formMode === "add" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onSubmit}>
                      <AddIcon />
                      Submit
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}

              {formMode === "edit" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onUpdate}>
                      <ChangeCircleIcon />
                      Update
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Paper>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                sx={{ minWidth: 100 }}
              >
                <InputLabel id="rows-per-page-label">Rows per page</InputLabel>
                <Select
                  labelId="rows-per-page-label"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  label="Rows per page"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ width: 250 }}
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <div className="table-container">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Location Desc</th>
                    <th>Sub Location Desc</th>
                    <th>Sub Location Name</th>
                    <th>Status</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Updated By</th>
                    <th>Updated Date</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRows.map((company) => (
                    <tr key={company.SubLoc_Id}>
                      <td data-label="Select">
                        <button onClick={() => handleRowSelect(company)}>
                          Select
                        </button>
                      </td>
                      <td data-label="Location Desc">{company.Loc_Code}</td>
                      <td data-label="Sub Location Desc">
                        {company.SubLoc_Code}
                      </td>
                      <td data-label="Sub Location Name">
                        {company.SubLoc_Name}
                      </td>
                      <td data-label="Status">{company.Status}</td>
                      <td data-label="Created By">{company.CreatedBy}</td>
                      <td data-label="Created Date">
                        {new Date(company.CreatedDate).toLocaleString()}
                      </td>
                      <td data-label="Updated By">{company.ModifyBy}</td>
                      <td data-label="Updated Date">
                        {company.ModifyDate
                          ? new Date(company.ModifyDate).toLocaleString()
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Typography variant="body2" sx={{ marginRight: 2 }}>
                Showing {(page - 1) * rowsPerPage + 1} to{" "}
                {Math.min(page * rowsPerPage, filteredRows.length)} of{" "}
                {filteredRows.length} entries
              </Typography>
              <Pagination
                count={Math.ceil(filteredRows.length / rowsPerPage)}
                page={page}
                onChange={handleChangePage}
                size="small"
              />
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default SubLocationMaster;
